import Client from './client';

export default class SessionOrderData extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getBySessionId(sessionId, options = {}) {
    return this.makeRequest(`${this.host}/session/order/data/${sessionId}`, options);
  }

}
